import {
  REDUX_DOMAIN_LIST_KEY,
  REDUX_DOMAIN_LIST_SECTION_KEY
} from '../../constants/key'
import { joinPathsStringUtil } from '../../../../utils/string/get-joined-paths'

export default function getByQueryPathReduxUtil (path, query) {
  if (!query) {
    return joinPathsStringUtil(path, REDUX_DOMAIN_LIST_KEY.ALL)
  }
  // e.g. exercises.byQuery.abs
  return joinPathsStringUtil(path,
    REDUX_DOMAIN_LIST_SECTION_KEY.BY_QUERY,
    query
  )
}
